import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: BASE, withCredentials: true });

export const api = {
  // auth
  register: (email, password, name) => client.post("/auth/register", { email, password, name }).then(r => r.data),
  login: (email, password) => client.post("/auth/login", { email, password }).then(r => r.data),
  googleSession: (session_id) => client.post("/auth/session", { session_id }).then(r => r.data),
  me: () => client.get("/auth/me").then(r => r.data),
  logout: () => client.post("/auth/logout").then(r => r.data),
  // billing
  getPlans: () => client.get("/billing/plans").then(r => r.data),
  subscribe: (plan) => client.post("/billing/subscribe", { plan }).then(r => r.data),
  activate: (email, plan) => client.post("/billing/activate", { email, plan }).then(r => r.data),
  getSubscribers: () => client.get("/admin/subscribers").then(r => r.data),
  getUsers: () => client.get("/admin/users").then(r => r.data),
  // allowlist
  getAllowlist: () => client.get("/allowlist").then(r => r.data),
  addAllowlist: (value, note = "") => client.post("/allowlist", { value, note }).then(r => r.data),
  deleteAllowlist: (id) => client.delete(`/allowlist/${id}`).then(r => r.data),
  // scans
  createScan: (payload) => client.post("/scans", payload).then(r => r.data),
  listScans: () => client.get("/scans").then(r => r.data),
  getScan: (id) => client.get(`/scans/${id}`).then(r => r.data),
  deleteScan: (id) => client.delete(`/scans/${id}`).then(r => r.data),
  // schedules
  listSchedules: () => client.get("/schedules").then(r => r.data),
  createSchedule: (payload) => client.post("/schedules", payload).then(r => r.data),
  toggleSchedule: (id) => client.post(`/schedules/${id}/toggle`).then(r => r.data),
  deleteSchedule: (id) => client.delete(`/schedules/${id}`).then(r => r.data),
  toolsHealth: () => client.get("/tools/health").then(r => r.data),
  installTools: () => client.post("/admin/install-tools").then(r => r.data),
  toolsLog: () => client.get("/tools/health/log").then(r => r.data),
  // aggregates
  getVulnerabilities: () => client.get("/vulnerabilities").then(r => r.data),
  getStats: () => client.get("/stats").then(r => r.data),
};

export default api;
